import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import type { Schema } from '../../services/api';

interface DraftMetadataCardProps {
  draft: Schema;
  selectedProjectId: string | null;
  suggestedName: string;
  tableCount: number;
}

const DraftMetadataCard: React.FC<DraftMetadataCardProps> = ({
  draft,
  selectedProjectId,
  suggestedName,
  tableCount,
}) => (
  <Card variant="outlined">
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Draft Metadata
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="text.secondary">
            Schema ID
          </Typography>
          <Typography variant="body2" fontFamily="monospace">
            {draft.schema_id}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="text.secondary">
            Project ID
          </Typography>
          <Typography variant="body2">
            {draft.project_id ?? selectedProjectId ?? '\u2014'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="text.secondary">
            Target Schema
          </Typography>
          <Typography variant="body2">
            {draft.schema_id}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="text.secondary">
            Source Type
          </Typography>
          <Typography variant="body2">{draft.source_type}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="text.secondary">
            Created
          </Typography>
          <Typography variant="body2">
            {draft.created_at ? new Date(draft.created_at).toLocaleString() : '\u2014'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="text.secondary">
            Suggested Name
          </Typography>
          <Typography variant="body2">{suggestedName || '\u2014'}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="text.secondary">
            Table Count
          </Typography>
          <Typography variant="body2">{tableCount}</Typography>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default DraftMetadataCard;
